import { FloatingFormItem, Group, InputDecimal } from '@/components/_common';
import { useDirectSaleApplyTotalDiscount } from '@/core/domain/sales/DirectSale/DirectSale.hooks';
import { useDefaultEmptyFieldError } from '@/hooks';
import formatterPrice from '@/utils/number/formatterPrice';
import { Col, Divider, Form, Modal, ModalProps, Row, Typography } from 'antd';
import { FaExclamationTriangle } from 'react-icons/fa';

const { Text } = Typography;

interface Props extends ModalProps {
  totalItens?: number;
  directSaleId?: number;
  onCancel: VoidFunction;
}

const DirectSaleItemsDiscountModal = ({
  directSaleId,
  totalItens = 0,
  ...props
}: Props) => {
  const [form] = Form.useForm<{ discountValue: number }>();
  const discountValue = Form.useWatch('discountValue', form);

  const requiredField = useDefaultEmptyFieldError();

  const directSaleApplyTotalDiscount = useDirectSaleApplyTotalDiscount();

  const handleOk = async () => {
    if (directSaleId) {
      await form.validateFields();

      await directSaleApplyTotalDiscount.mutateAsync({
        discountValue,
        saleId: directSaleId,
      });
    }

    props.onCancel();
  };

  return (
    <Modal
      {...props}
      okText="Salvar"
      destroyOnClose
      onOk={handleOk}
      confirmLoading={directSaleApplyTotalDiscount.isLoading}
      title={
        <Group gap={10}>
          <FaExclamationTriangle color="#f33e3e" size={24} /> Atenção
        </Group>
      }
    >
      <Form form={form} preserve={false}>
        <Text>
          Ao alterar o valor total de desconto em peça, o valor do desconto em
          cada peça será alterado de forma proporcional ao valor total recém
          alterado e ao valor total da peça!
        </Text>

        <Divider />

        <Row gutter={[16, 8]}>
          <Col span={24}>
            <FloatingFormItem
              name="discountValue"
              label="Desconto(R$)"
              rules={[
                requiredField,
                {
                  max: totalItens,
                  type: 'number',
                  message: `Limite máximo ${formatterPrice(totalItens)}`,
                },
              ]}
            >
              <InputDecimal
                fractions={2}
                max={totalItens}
                min={0}
                disabled={directSaleApplyTotalDiscount.isLoading}
              />
            </FloatingFormItem>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default DirectSaleItemsDiscountModal;
